<template>
  <!-- QR generation Error Modal -->
  <CModal
    alignment="center"
    :backdrop="true"
    :visible="qrErrorModalShow"
    @close="closeModal()"
  >
    <CModalHeader
      style="
        background: #ee3e42;
        height: 70px;
        border-bottom-left-radius: 50% 10%;
        border-bottom-right-radius: 50% 10%;
      "
    >
    </CModalHeader>
    <CModalBody>
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
        "
      >
        <img :src="cross" :height="80" :width="80" style="margin-top: -50px" />
      </div>
      <div
        style="
          margin-top: 30px;
          margin-bottom: 10px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;
          text-align: center;
        "
      >
        <div style="color: #ee3e42"><h4>ERROR!</h4></div>
        <div>
          {{ message }}
        </div>
      </div>
    </CModalBody>
    <div style="display: flex; justify-content: center; padding: 1rem">
      <CButton
        class="rounded-custom px-4"
        style="background-color: #fe7235; width: 100px; color: white"
        @click="closeModal()"
      >
        Ok
      </CButton>
    </div>
  </CModal>

  <!-- Confirmation Modal -->
  <CModal
    :backdrop="true"
    :visible="confirmationModalShow"
    @close="closeModal()"
  >
    <CModalHeader style="background: #ffd130">
      <CModalTitle>{{ title }}</CModalTitle>
    </CModalHeader>
    <CModalBody>{{ message }}</CModalBody>
    <CModalFooter>
      <CButton color="primary" style="float: right" @click="confirmAction()">
        Yes
      </CButton>
      <CButton color="light" style="float: right" @click="closeModal()">
        No
      </CButton>
    </CModalFooter>
  </CModal>

  <!-- Confirmation Modal with Reason -->
  <CModal :backdrop="true" :visible="reasonModalShow" @close="closeModal()">
    <CModalHeader style="background: #ffd130">
      <CModalTitle>{{ title }}</CModalTitle>
    </CModalHeader>
    <CModalBody>
      {{ message }}
      <CCol :sm="12" style="margin-top: 10px">
        <CFormInput
          type="text"
          v-model="reason"
          placeholder="Enter Reason"
          required
        />
      </CCol>
    </CModalBody>
    <CModalFooter>
      <CButton
        color="primary"
        style="float: right"
        :disabled="reason == ''"
        @click="methodAction()"
      >
        Yes
      </CButton>
      <CButton color="light" style="float: right" @click="closeModal()">
        No
      </CButton>
    </CModalFooter>
  </CModal>

  <!-- Success Modal -->
  <CModal :backdrop="true" :visible="successModalShow" @close="success()">
    <CModalHeader style="background: #54cc8a">
      <CModalTitle>{{ title }}</CModalTitle>
    </CModalHeader>
    <CModalBody style="color: black">{{ message }}</CModalBody>
    <CModalFooter>
      <CButton color="primary" style="float: right" @click="success()">
        Ok
      </CButton>
    </CModalFooter>
  </CModal>

  <!-- Unsuccessful Modal -->
  <CModal :backdrop="true" :visible="unsuccessModalShow" @close="closeModal()">
    <CModalHeader style="background: #de595f">
      <CModalTitle>{{ title }}</CModalTitle>
    </CModalHeader>
    <CModalBody>{{ message }}</CModalBody>
    <CModalFooter>
      <CButton color="primary" style="float: right" @click="closeModal()">
        Ok
      </CButton>
    </CModalFooter>
  </CModal>
</template>

<script>
import cross from '@/assets/images/cross.png'
import successtick from '@/assets/images/Group 4501.png'

export default {
  setup() {
    return { successtick, cross }
  },
  data() {
    return {
      reason: ''
    }
  },
  props: {
    message: String,
    title: String,
    unsuccessModalShow: Boolean,
    confirmationModalShow: Boolean,
    successModalShow: Boolean,
    reasonModalShow: Boolean,
    qrErrorModalShow: Boolean,
    deleteMessage: Boolean,
    method: { type: Function },
    close: { type: Function },
    reload: { type: Function },
    methodReason: { type: Function }
  },
  name: 'Modal',
  methods: {
    confirmAction() {
      this.close()
      this.method()
    },
    closeModal() {
      this.close()
    },
    success() {
      this.close()
      this.reload()
    },
    methodAction() {
      this.close()
      this.methodReason(this.reason)
    }
  }
}
</script>

<style>
.modal {
  display: flex;
  justify-content: end;
}
.v-leave-active,
.v-leave-to {
  visibility: hidden !important;
}

.modal.fade.show {
  display: block !important;
}

.modal.fade {
  display: none !important;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.rounded-custom {
  border-radius: 20px;
}
</style>
